import { instance } from "../apiBase/instance";

export const AdminApi = {
    GetDashboardSummary() {
        return instance.get<any>(`api/admin/summary`);
    },
    GetListUsers(params: any) {
        return instance.get<any>(`api/users?search=${params.search}&page=${params.page}&limit=${params.limit}&sortOrder=${params.sortOrder}`);
    },
    GetListTransactions(params: any) {
        return instance.get<any>(`api/admin/transactions?search=${params.search}&status=${params.status}&page=${params.page}&limit=${params.limit}`);
    },
    GetListReconciliation(params: any) {
        return instance.get<any>(`api/reconciliation/list?status=${params.status}&startDate=${params.startDate}&endDate=${params.endDate}&page=${params.page}&limit=${params.limit}`);
    },
    PartnerConfirmReconciliation(params: any) {
        return instance.post<any>(`api/reconciliation/partner-confirm`, params);
    },
    PwcConfirmReconciliation(params: any) {
        return instance.post<any>(`api/reconciliation/pwc-confirm`, params);
    },
    PartnerUpdateHash(params: any) {
        return instance.post<any>(`api/reconciliation/update-hash`, params);
    },
    PwcFinalConfirmReconciliation(params: any) {
        return instance.post<any>(`api/reconciliation/pwc-final-confirm`, params);
    },
}